module.exports = "https://www.svtstatic.se/play/play7/_next/static/images/svt-logo-white-87f695b7f2f785cf9289bdf2504f2b92.png";